export const SHOW_SNACKBAR = 'app/Snackbar/SHOW_SNACKBAR';
